import React, { useContext, useState, useEffect, useMemo } from 'react';
import { VegaFlex, VegaTable, VegaButtonLink, VegaPagination } from "@heartlandone/vega-react";
import { useLoaderData, useNavigate, useLocation } from "react-router-dom";
import { useNavigationHistory } from 'Navigation/NavigationHistoryProvider';
import { HubContext } from 'Redux/Context/context';
import ActivityDetailListItem from 'Components/ActivityDetailListItem/ActivityDetailListItem';
import { toggleGlobalModalAction } from 'Redux/Actions/actions';
import { openFormAction } from 'Redux/Actions/actions';
import { PATH } from 'Chore/Apis';
import { _fetch } from 'Chore/Request';
import {ACTIVITY_STATUS, FORM_NAME, MODULE} from 'Chore/Constants';

const { GET_ACTIVITY } = PATH;
const { MY_ACTIVITIES } = MODULE;
const { ACTIVITY_DETAIL } = MY_ACTIVITIES;
const { STATUS_LABEL } = ACTIVITY_STATUS;
function ViewMyRegisteredActivityDetail() {
  const { globalModalDispatch, myActivitiesState,formDispatch } = useContext(HubContext);
  useLocation();
  const params = useLoaderData();
  useNavigate();
  const [activity, setActivity] = useState({});
  const [guests, setGuests] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize] = useState(10);
  const { activityStatus } = activity;
  const { goBack } = useNavigationHistory();
  useEffect(() => {
    const { id } = params;
    if(!id) return;
    getCurrentActivity(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myActivitiesState]);

  useEffect(() => {
    const { id } = params;
    if(!id) return;
    _loadActivityRegisterInfo({id})
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fallback fetch when refreshing directly (context activities not yet loaded)
  useEffect(() => {
    const { id } = params;
    if(!activity?.id && id){
      _toggleModal(true);
      _fetch({ api: `${GET_ACTIVITY}/${id}` })
        .then(res => {
          if(res?.code === 2200){
            setActivity(res?.payload || {});
          }
        })
        .finally(() => _toggleModal());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activity, params]);

  const getCurrentActivity = (id) => {
    const found = (myActivitiesState?.activities ?? []).find((a) => `${a.id}` === `${id}`);
    if(found){
      setActivity(found);
    }
  }

  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({isShow}));
  }

  const _loadActivityRegisterInfo = ({
    id,
  }) => {
    _toggleModal(true);
    _fetch({
      api: `${GET_ACTIVITY}/${id}/register`,
    }).then((res) => {
      if (res.code === 2200) {
        const guest = res?.payload?.guests || [];
        const staff = res?.payload?.staff ? [res.payload.staff] : [];
        const array = [...staff, ...guest];
        setGuests(array);
        setPageIndex(1);
        const timer = setTimeout(() => {
          clearTimeout(timer);
        }, 200);
      }
    }).finally(() => {
      _toggleModal();
    })
  }

  const onRigisterButtonClick = (e) => {
    e.preventDefault();
    formDispatch(openFormAction({ name: FORM_NAME['REGISTER_FORM'] , activity: {activity}, isEdit : true}));
  }
  const showEditRegister = () => {
    return (
        activityStatus === STATUS_LABEL.OPEN
    );
  }
  const total = guests.length;
  const pagedGuests = useMemo(() => {
    const start = (pageIndex - 1) * pageSize;
    return guests.slice(start, start + pageSize);
  }, [guests, pageIndex, pageSize]);
  const onPageChange = (e) => {
    const next = e.detail;
    setPageIndex(next);
  };

  return (
      <VegaFlex direction="col" gap="size-24" style={{ width: '100%' }} className='m-t-24 m-b-24'>
        <VegaFlex>
          <VegaButtonLink
            label="Back"
            icon="fa-solid fa-angle-left"
            onVegaClick={() => goBack('/my-activity?category=Registered')}
          />
        </VegaFlex>
        
        <VegaFlex  direction={'col'} gap={'size-12'}>
          <ActivityDetailListItem activity={activity} module={ACTIVITY_DETAIL}/>
        {

            <VegaFlex justifyContent={'space-between'} alignItems={'center'}>
                <h2 className='m-0'>My Registration</h2>
                {
                    showEditRegister() &&
                    <VegaButtonLink label="Edit Registration" onVegaClick={onRigisterButtonClick} icon="fa-solid fa-pen-to-square" />
                }
            </VegaFlex>
        }
          
          <VegaTable
                columns={[
                  {
                    label: "Name",
                    prop: "name",
                  }, {
                    label: "Native Name",
                    prop: "nativeName",
                  }, {
                    label: "Location",
                    prop: "location",
                  }, {
                    label: "Allocation",
                    prop: "allocation",
                  }, {
                    label: "Phone Number",
                    prop: "phone",
                  }, {
                    label: "Email",
                    prop: "email",
                  }, {
                    label: "Note",
                    prop: "note",
                  },
                ]}
                rowKey = "name"
                dataSource={pagedGuests}
              />

          <VegaFlex className='m-t-16' justifyContent='end'>
            <VegaPagination
              total={total}
              pageSize={pageSize}
              current={pageIndex}
              extensions={[["currentPageLabel","pageSelector"]]}
              onVegaChange={onPageChange}
            />
          </VegaFlex>

        </VegaFlex> 
      </VegaFlex>
  );
}

export default ViewMyRegisteredActivityDetail;
